<template>
  <button
    class="block w-full text-left px-4 py-2 border-b cursor-pointer hover:bg-EXPONDO-grey-5"
    @click="$emit('click', url)"
  >
    {{ url.label }}
  </button>
</template>

<script lang="ts">

import type { UseMyAccountPage } from '~~/types/myaccount/UseMyAccountPage';

export default defineComponent({
  name: 'MyAccountDropdownItem',
  props: {
    url: {
      type: Object as () => ReturnType<UseMyAccountPage>,
      required: true,
    },
  },
  emits: ['click'],
});

</script>
